import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let DeviceInfoCard = class DeviceInfoCard extends Vue {
    cardClick() {
        this.$emit('CardClick', this.deviceInfo);
    }
    getStatusColor() {
        const status = this.deviceInfo.bind ? (this.deviceInfo.status || '') : '未绑定';
        switch (status) {
            case '正常':
                return 'primary';
            case '返修':
                return 'secondary';
            case '故障':
                return 'error';
            case '停用':
                return 'warning';
            case '未绑定':
                return 'gray';
            default:
                return 'primary';
        }
    }
    mounted() {
    }
    async created() {
    }
};
__decorate([
    Prop({ default: () => { } })
], DeviceInfoCard.prototype, "deviceInfo", void 0);
DeviceInfoCard = __decorate([
    Component({})
], DeviceInfoCard);
export default DeviceInfoCard;
